<template>
  <div class="signup-welcome-page">
    <QHeader class="bg-transparent">
      <img class="header-logo" :src="require('@etab/assets/img/extra_logo_white.png')" :draggable="false" />
      <HeaderImageTitle :photo="require('@etab/assets/img/pricing_background.jpg')" :no-transparency="true">
        <QToolbar color="transparent">
          <QBtn round color="white" icon="icon-f-arrow-left" dense flat @click="goToLogin" />
        </QToolbar>
      </HeaderImageTitle>
    </QHeader>

    <QPageContainer>
      <QPage padding>
        <template v-if="isAuthenticated !== null">
          <SecondSteps :is-authenticated="isAuthenticated" @on-action="goToInfoSteps" />
        </template>
      </QPage>
    </QPageContainer>

    <ExtracadabraModal
      v-model:opened="successModalOpened"
      :body="{ class: 'text-center' }"
      size="xs"
      :quasar-props="{ maximized: false }"
      :header="{
        hideCloseBtn: true,
      }"
    >
      <template #body>
        <QIcon name="icon-extra-reward" color="secondary" size="94px" class="q-mb-lg" />

        <h4>{{ $t("ETAB.MODALS.INSCRIPTION_SUCCESS.@TITLE") }}</h4>
        <h5>{{ $t("ETAB.MODALS.INSCRIPTION_SUCCESS.@TEXT") }}</h5>
      </template>
      <template #footer>
        <QBtn v-close-popup color="secondary" :label="$t('ETAB.BUTTONS.@OK')" class="full-width btn-navigation" no-caps />
      </template>
    </ExtracadabraModal>
  </div>
</template>

<script>
  import { AuthenticationManager } from "@core/managers/authentication.manager";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { ETAB_ROUTES } from "@etab/config";
  import { GETTER_SIGNUP_GET } from "@etab/stores/types";
  import { useSignupStore } from "@etab/stores/signup";
  import { mapState } from "pinia";
  import { ExtracadabraModal } from "@core/components/modals";
  import { FIREBASE_EVENTS } from "@core/constants";

  import HeaderImageTitle from "@etab/components/dashboard/HeaderImageTitle.component.vue";
  import SecondSteps from "@etab/components/onboarding/signup/SecondSteps.component.vue";

  export default {
    components: {
      HeaderImageTitle,
      SecondSteps,
      ExtracadabraModal,
    },
    data() {
      return {
        successModalOpened: false,
        isAuthenticated: null,
      };
    },
    computed: {
      ...mapState(useSignupStore, {
        signupModel: GETTER_SIGNUP_GET,
      }),
    },
    async created() {
      this.isAuthenticated = await AuthenticationManager.isUserAuthenticated();
    },
    mounted() {
      this.checkSuccess();
    },
    methods: {
      checkSuccess() {
        if (this.$route.params.success) {
          this.openSuccessModal();
        }
      },
      openSuccessModal() {
        this.successModalOpened = true;
      },
      goToMainSteps() {
        TrackingManager.addEvent({
          event: FIREBASE_EVENTS.FUNNEL,
          step: "step3_start",
        });
        this.$router.push({ name: ETAB_ROUTES.signup.steps.main.name }).catch((suppressedError) => {});
      },
      goToInfoSteps() {
        this.$router.push({ name: ETAB_ROUTES.signup.steps.info.root.name }).catch((suppressedError) => {});
      },
      skipInfoSteps() {
        this.$router.push({ name: ETAB_ROUTES.signup.steps.success.name, query: { skipped: true } }).catch((suppressedError) => {});
      },
      goToLogin() {
        const email = this.signupModel.getEmail();
        this.$router.push({ name: ETAB_ROUTES.auth.login.name, query: { prefilledEmail: email } }).catch((suppressedError) => {});
      },
    },
  };
</script>

<style lang="scss" scoped>
  .signup-welcome-page {
    img.header-logo {
      position: absolute;
      height: 105px;
      z-index: 1;
      left: calc(50% - 50px);
      top: calc(max(50px, 50% - 75px));
    }

    .header-image-title {
      background-size: 115%;
      background-position: 25% center;
    }

    hr {
      margin: 30px 10px;
      opacity: 0.5;
      border-color: $primary-lighter;
    }
  }
</style>
